import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import { FormikErrors, FormikTouched } from 'formik';
import { OutsideMilanPlaceVM } from 'front-office/view-models/authorization-vote';
import MunicipalityList from 'shell/components/shared/municipality-list';
import { DateTime } from 'luxon';

interface OutsideMilanPlaceComponentProps {
  values?: OutsideMilanPlaceVM | null;
  onChange: (
    key: keyof OutsideMilanPlaceVM,
    value: OutsideMilanPlaceVM[keyof OutsideMilanPlaceVM]
  ) => void;
  disabled?: boolean;
  touched?: FormikTouched<OutsideMilanPlaceVM>;
  errors?: FormikErrors<OutsideMilanPlaceVM>;
}

const OutsideMilanPlaceComponent = ({
  values,
  onChange,
  disabled,
  touched,
  errors,
}: OutsideMilanPlaceComponentProps): React.ReactElement => {
  return (
    <>
      <Grid item xs={12} md={8}>
        <PmiTextField
          aria-label="Luogo Casa di cura"
          label="Luogo Casa di cura"
          id="place"
          name="place"
          type="text"
          onChange={(event) => {
            onChange('place', event.target.value);
          }}
          fullWidth
          variant="outlined"
          value={values?.place || ''}
          disabled={disabled}
          error={touched?.place && Boolean(errors?.place)}
          helperText={errors?.place}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data richiesta *"
          aria-label="Data richiesta *"
          value={values?.requestDate || null}
          disabled={disabled}
          onChange={(date) => {
            onChange('requestDate', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="requestDate"
              fullWidth
              error={touched?.requestDate && Boolean(errors?.requestDate)}
              helperText={errors?.requestDate}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MunicipalityList
          value={values?.municipality || null}
          onChange={(el) => {
            onChange('municipality', el);
          }}
          label="Comune"
          required
          fromDate={DateTime.now()}
          error={touched?.municipality && Boolean(errors?.municipality)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Provincia"
          label="Provincia"
          id="province"
          name="province"
          type="text"
          fullWidth
          variant="outlined"
          value={values?.municipality?.province || ''}
          disabled
        />
      </Grid>
    </>
  );
};

OutsideMilanPlaceComponent.displayName = 'Outside milan  component';

const OutsideMilanPlace = memo(OutsideMilanPlaceComponent);

export default OutsideMilanPlace;
